export const Roles = {
    ADMIN: 'Admin',
    DISPATCHER: 'Dispatcher',
    FINANCE: 'Finance',
};
